module.exports = __webpack_public_path__ + "media/images/undraw/reserve/emails-d8ee6de076b71f8aeabdd2f678888dfd.png";